export const FREELANCER_ONBOARDING_LOCK_TOOLTIP =
  'Доступ к платформе откроется после заполнения профиля';

export const FREELANCER_ONBOARDING_REDIRECT_URL = '/platform/company-settings';

export const FREELANCER_ONBOARDING_TRAINING_BANNER = {
  title: 'Пройдите обучение',
  subtitle: 'по работе с платформой',
  actionLabel: 'Смотреть',
  planeAsset: 'assets/agency-landing/cta-plane.png',
} as const;
